import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { themes, ThemeName, getTheme } from '../themes/themes';
import './ThemePreviewPage.css';

const ThemePreviewPage: React.FC = () => {
  const { currentTheme, setTheme } = useTheme();

  return (
    <div className="theme-preview-page">
      <div className="theme-preview-header">
        <h1>Theme Preview</h1>
        <p>Compare all available themes side-by-side</p>
        <p style={{ fontSize: '0.875rem', marginTop: '0.5rem' }}>
          <a href="/app" style={{ color: 'var(--color-primary, #2563eb)' }}>← Back to App</a>
        </p>
      </div>

      <div className="theme-preview-grid">
        {(Object.keys(themes) as ThemeName[]).map((themeName) => {
          const theme = getTheme(themeName);
          const isActive = currentTheme === themeName;

          return (
            <div
              key={themeName}
              className={`theme-preview-card ${isActive ? 'active' : ''}`}
              style={{
                backgroundColor: theme.colors.background,
                borderColor: theme.colors.border,
              }}
            >
              <div className="theme-preview-card-header">
                <h3>{theme.displayName}</h3>
                {isActive && <span className="active-badge">Active</span>}
              </div>

              <p className="theme-preview-description">{theme.description}</p>

              <div className="theme-preview-sections">
                <div
                  className="theme-preview-section"
                  style={{ backgroundColor: theme.colors.sectionBackground }}
                >
                  <div className="theme-preview-card-example" style={{ backgroundColor: theme.colors.card }}>
                    <div className="theme-preview-card-content">
                      <div className="theme-preview-title" style={{ color: theme.colors.text }}>
                        Sample Card
                      </div>
                      <div className="theme-preview-text" style={{ color: theme.colors.textSecondary }}>
                        This is how cards look in this theme
                      </div>
                      <button
                        className="theme-preview-button"
                        style={{
                          backgroundColor: theme.colors.primary,
                          color: 'white',
                        }}
                      >
                        Primary Button
                      </button>
                      <button
                        className="theme-preview-button secondary"
                        style={{
                          backgroundColor: theme.colors.secondary,
                          color: 'white',
                        }}
                      >
                        Secondary Button
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="theme-preview-colors">
                <div className="color-swatch">
                  <div
                    className="color-preview"
                    style={{ backgroundColor: theme.colors.background }}
                  ></div>
                  <span>Background</span>
                </div>
                <div className="color-swatch">
                  <div
                    className="color-preview"
                    style={{ backgroundColor: theme.colors.sectionBackground }}
                  ></div>
                  <span>Section</span>
                </div>
                <div className="color-swatch">
                  <div
                    className="color-preview"
                    style={{ backgroundColor: theme.colors.card }}
                  ></div>
                  <span>Card</span>
                </div>
                <div className="color-swatch">
                  <div
                    className="color-preview"
                    style={{ backgroundColor: theme.colors.border }}
                  ></div>
                  <span>Border</span>
                </div>
              </div>

              <button
                className="theme-preview-select-button"
                onClick={() => setTheme(themeName)}
                style={{
                  backgroundColor: isActive ? theme.colors.primary : 'transparent',
                  color: isActive ? 'white' : theme.colors.primary,
                  borderColor: theme.colors.primary,
                }}
              >
                {isActive ? 'Currently Active' : 'Select This Theme'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThemePreviewPage;

